import React, { useState, useEffect, useRef } from "react";
import { FiFolder, FiEdit2 } from "react-icons/fi";
import { FiExternalLink } from "react-icons/fi";
import { BsThreeDots } from "react-icons/bs";
import styles from "./CustomCard.module.css";
import CustomButton from "../CustomButton";
import DeleteModel from "../modals/DeleteModel";

const CustomCard = ({
  title,
  description,
  icon = <FiFolder size={20} className="text-primary" />,
  buttonText = "Open Workstream",
  onButtonClick = () => {},
  onDelete = () => {},
  onEdit = () => {}, // Add onEdit prop
  showDeleteConfirmation = true, // to show delete confirmation & Delete icon
  className = "",
}) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleDelete = () => {
    if (showDeleteConfirmation) {
      setShowConfirm(true);
      setMenuOpen(false);
    } else {
      onDelete();
    }
  };

  const handleEdit = () => {
    onEdit();
    setMenuOpen(false);
  };

  const confirmDelete = () => {
    onDelete();
    setShowConfirm(false);
  };

  return (
    <>
      <div className={`card shadow-sm p-3  ${styles.customCard} `}>
        <div className="d-flex justify-content-between align-items-start ">
          <div className="rounded d-inline-flex align-items-center justify-content-center p-2" style={{ backgroundColor: "rgba(11, 166, 255, 0.09)", color: "#0ba6ff" }}>
            {icon}
          </div>
          <div className="position-relative" style={{cursor:"pointer"}} ref={menuRef}>
            {showDeleteConfirmation && (
            <BsThreeDots
              size={20}
              className="text-muted "
              onClick={() => setMenuOpen(!menuOpen)}
            />
            )}
            {menuOpen && (
              <div className={`dropdown-menu show  ${styles.dropdownMenu}`}>
                <button className="d-flex dropdown-item m-0 btn " onClick={handleEdit}>
                  <span className="p-0 "> Edit</span>
                </button>
                <button className="d-flex dropdown-item m-0 btn " onClick={handleDelete}>
                  <span className="p-0 "> Delete</span>
                </button>
              </div>
            )}
          </div>
        </div>
        <div className="mt-3">
        <h6 className="fw-bold mb-1 ">{title}</h6>
        <p
           className="text-muted small  text-wrap"
           style={{
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
            WebkitLineClamp: 2,
            maxWidth: "400px",
            height: "41px"
          }}
        >
          {description}
        </p>
        </div>
        
        <CustomButton
          onClick={onButtonClick}
          variant="outline"
          className={`btn-sm px-3 py-2 w-100 justify-between ${styles.customButton}`}
        >
          <span className="flex-grow-1 text-start">{buttonText}</span>
          <FiExternalLink size={18} />
        </CustomButton>
      </div>

      {showConfirm && (
        <DeleteModel
          open={showConfirm}
          closeAlert={() => setShowConfirm(false)}
          onClick={confirmDelete}
          type="file"
        />
      )}
    </>
  );
};

export default CustomCard;

//  CustomCard Component Usage
//   return (
//     
//       <CustomCard
//         title="Workstream 1"
//         description="This is a description of the first workstream"
//         icon={<FiFolder size={20} />} 
//         buttonText="Open Workstream"
//         onButtonClick={handleButtonClick} // Handles the "Open Workstream" button click
//         onDelete={handleDelete} // Handles the delete action
//         showDeleteConfirmation={true} // Show delete confirmation & delete icon
//         className="additional-class" // Additional CSS class, optional
//       />